import { useNavigate, useLocation } from "react-router-dom";
import TrialDetail from "shared/Trail/TrialDetail";


export const ManageTrailDetailsReports = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customData } = location.state || {};
  const onGoBack = () => {
    navigate("/admin/trial/reports");
  };
  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <TrialDetail detail={customData} goBack={onGoBack} smPadding={true} />
    </div>
  );
};
